import React, { useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { auth, provider } from '../firebase/firebase';
import './Login.css'; // Import der CSS-Datei
import logo from '../assets/logo2.png';

function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    setIsLoading(true);
    setError(null);

    try {
      await signInWithPopup(auth, provider);
      window.location.href = '/dashboard';
    } catch (error) {
      console.error('Anmeldefehler:', error);
      let errorMessage = 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.';

      if (error.code) {
        switch (error.code) {
          case 'auth/popup-blocked':
            errorMessage = 'Pop-up wurde blockiert. Bitte erlaube Pop-ups für diese Seite.';
            break;
          case 'auth/popup-closed-by-user':
            errorMessage = 'Anmeldung abgebrochen.';
            break;
          case 'auth/network-request-failed':
            errorMessage = 'Netzwerkfehler. Bitte überprüfe deine Internetverbindung.';
            break;
          default:
            errorMessage = 'Ein unerwarteter Fehler ist aufgetreten.';
        }
      }
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <header className="login-header">
          <img src={logo} alt="Sirius Logo" className="login-logo" />
          <h2 className="login-title">Dashboard</h2>
          <p className="login-subtitle">Melde dich mit Google an, um fortzufahren</p>
        </header>

        {error && (
          <div className="error-container">
            <p className="error-message">{error}</p>
            <button
              onClick={() => setError(null)}
              className="error-close"
              aria-label="Fehler schliessen"
            >
              ×
            </button>
          </div>
        )}

        <button
          onClick={handleLogin}
          disabled={isLoading}
          className={`google-button ${isLoading ? 'google-button-disabled' : ''}`}
        >
          {isLoading ? (
            <div className="loading-spinner"></div>
          ) : (
            <>
              <svg className="google-icon" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1Z"
                />
              </svg>
              <span>Anmelden mit Google</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
}

export default Login;